<template>
  <v-flex xs12>
    <v-layout row wrap fill-height>
      <!-- ERROR SNIPPET -->
      <v-snackbar
        v-model="error.show"
        color="error"
        top
        :timeout="error.timeout"
        text-xs-center
      >
        {{ error.message }}
        <v-icon right dark>error_outline</v-icon>
      </v-snackbar>

      <!-- LOGO -->
      <v-flex xs12>
        <img
          :src="require('@/assets/img/logo_e-egyetem_classroom_logo_white.png')"
          alt="logo"
          class="img-fluid"
          style="max-width: 250px;"
        />
        <h3 class="mt-5">Lépj be a nyelvtanulás új világába</h3>
      </v-flex>

      <!-- LOADER -->
      <v-flex xs12 v-show="loader">
        <v-progress-circular
          dark
          color="white"
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-flex>

      <!-- LOGIN -->
      <v-flex offset-xs2 xs8 v-show="login">
        <v-form>
          <v-text-field
            prepend-icon="alternate_email"
            name="login"
            label="Email cím"
            type="text"
            dark
            :rules="[rules.required]"
            v-model="formLogin.email"
          ></v-text-field>
          <v-text-field
            id="password"
            prepend-icon="lock"
            name="password"
            label="Jelszó"
            type="password"
            dark
            :rules="[rules.required]"
            v-model="formLogin.password"
          ></v-text-field>

          <!--                    <v-checkbox v-model="formLogin.remember" dark>-->
          <!--                        <template v-slot:label>-->
          <!--                            Bejelentkezve maradok-->
          <!--                        </template>-->
          <!--                    </v-checkbox>-->
        </v-form>

        <v-btn color="white" x-large @click="authenticate()" tile flat>
          Bejelentkezés
          <!-- <v-icon right dark>input</v-icon> -->
        </v-btn>
        <v-btn
          color="white"
          x-large
          @click="
            login = false;
            registration = true;
          "
          tile
          flat
        >
          Regisztráció
          <!-- <v-icon right dark>meeting_room</v-icon>  -->
        </v-btn>
        <v-btn color="white" x-large @click="goToPasswordReset()" tile flat>
          Elfelejtett jelszó
          <!-- <v-icon right dark>meeting_room</v-icon> -->
        </v-btn>
      </v-flex>

      <!-- REGISTRATION -->
      <v-flex offset-xs2 xs8 v-show="registration">
        <v-form class="p-2">
          <v-text-field
            dark
            prepend-icon="person"
            name="name"
            label="Név"
            type="text"
            :rules="[rules.required]"
            v-model="form.name"
          ></v-text-field>
          <v-text-field
            dark
            prepend-icon="alternate_email"
            name="login"
            label="E-mail cím"
            type="text"
            :rules="[rules.required]"
            v-model="form.email"
          ></v-text-field>
          <v-text-field
            dark
            prepend-icon="alternate_email"
            name="login"
            label="E-mail cím megerősítése"
            type="text"
            :rules="[rules.required]"
            v-model="form.email2"
          ></v-text-field>
          <v-text-field
            dark
            prepend-icon="lock"
            name="password"
            label="Jelszó"
            :rules="[rules.required]"
            :append-icon="form.passwordShow ? 'visibility' : 'visibility_off'"
            :type="form.passwordShow ? 'text' : 'password'"
            @click:append="form.passwordShow = !form.passwordShow"
            v-model="form.password"
          ></v-text-field>
          <v-text-field
            dark
            prepend-icon="lock"
            name="password"
            label="Jelszó"
            :rules="[rules.required]"
            :append-icon="form.passwordShow2 ? 'visibility' : 'visibility_off'"
            :type="form.passwordShow2 ? 'text' : 'password'"
            @click:append="form.passwordShow2 = !form.passwordShow2"
            v-model="form.password2"
          ></v-text-field>
          <v-checkbox v-model="form.checkbox.aszf" dark>
            <template v-slot:label>
              <a
                style="color: white;"
                target="_blank"
                href="https://admin.skillers.hu/skillers_aszf.pdf"
              >
                Elfogadom az ÁSZF-t
              </a>
            </template>
          </v-checkbox>
          <v-checkbox v-model="form.checkbox.gdpr" dark>
            <template v-slot:label>
              <a
                style="color: white;"
                target="_blank"
                href="https://admin.skillers.hu/skillers_gdpr.pdf"
              >
                Elolvastam és elfogadtam az adatkezelési tájékoztatót
              </a>
            </template>
          </v-checkbox>
        </v-form>

        <v-btn color="white" x-large @click="letsRegistrate()" tile flat>
          Regisztráció
          <!-- <v-icon right dark>meeting_room</v-icon> -->
        </v-btn>
        <v-btn
          color="white"
          x-large
          @click="
            login = true;
            registration = false;
          "
          tile
          flat
        >
          Bejelentkezés
          <!-- <v-icon right dark>input</v-icon> -->
        </v-btn>
        <v-btn color="white" x-large @click="goToPasswordReset()" tile flat>
          Elfelejtett jelszó
          <!-- <v-icon right dark>meeting_room</v-icon> -->
        </v-btn>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    error: {
      show: false,
      message: "",
      timeout: 4500
    },
    rules: {
      required: value => !!value || "Kötelező"
    },
    loader: false,
    login: true,
    registration: false,
    formLogin: {
      email: "",
      password: "",
      remember: ""
    },
    form: {
      email: "",
      email2: "",
      name: "",
      password: "",
      passwor2: "",
      passwordShow: false,
      passwordShow2: false,
      checkbox: {
        aszf: false,
        gdpr: false
      }
    }
  }),
  methods: {
    authenticate() {
      this.$store.dispatch("login");

      this.$data.login = false;
      this.$data.loader = true;

      axios
        .post(this.$store.getters.getApiUrl + "/api/login", {
          email: this.$data.formLogin.email,
          password: this.$data.formLogin.password
        })
        .then(response => {
          if (response.data.token.length > 0) {
            this.$store.commit("loginSuccess", {
              token: response.data.token,
              isLoggedIn: true,
              currentUser: response.data.currentUser
            });

            this.$store.commit("setIsAppState", {
              isApp: true
            });

            //Automaticaly save the email & pwd
            // if( this.$data.formLogin.remember === true )
            // {
            localStorage.loginEmail = this.$data.formLogin.email;
            localStorage.loginPassword = this.$data.formLogin.password;
            // }

            var v = this;

            setTimeout(function() {
              v.$data.loader = false;
              v.$router.push({ path: "/chooser" });
            }, 2000);
          }
        })
        .catch(error => {
          // console.log('error', error.response.data);

          var v = this;

          setTimeout(function() {
            v.$data.loader = false;
            v.$data.login = true;
            v.$data.error.message = error.response.data.message;
            v.$data.error.code = error.response.data.code;
            v.$data.error.show = true;
          }, 1000);
        });
    },
    letsRegistrate() {
      this.$data.error.show = false;

      if (
        this.$data.form.checkbox.aszf === false ||
        this.$data.form.checkbox.gdpr === false
      ) {
        this.$data.error.message = "ÁSZF és GDPR elfogadása kötelező!";
        this.$data.error.code = "000";
        this.$data.error.show = true;
      } else if (
        this.$data.form.email.length < 1 ||
        this.$data.form.name.length < 1
      ) {
        this.$data.error.message = "Az email cím és a név megadása kötelező!";
        this.$data.error.code = "000";
        this.$data.error.show = true;
      } else {
        this.$data.loader = true;
        this.$data.registration = false;

        axios
          .post(this.$store.getters.getApiUrl + "/api/registration", {
            email: this.$data.form.email,
            password: this.$data.form.password,
            name: this.$data.form.name
          })
          .then(response => {
            if (response.data.token !== undefined) {
              this.$store.commit("loginSuccess", {
                token: response.data.token,
                isLoggedIn: true,
                currentUser: response.data.currentUser
              });

              this.$store.commit("setIsAppState", {
                isApp: true
              });

              var v = this;
              setTimeout(function() {
                v.$data.loader = false;
                v.$router.push({ path: "/home" });
              }, 2000);
            }
          })
          .catch(error => {
            // console.log('Hibas reg: ', error.response);
            var v = this;

            setTimeout(function() {
              v.$data.loader = false;
              v.$data.registration = true;
              v.$data.error.message = error.response.data.message;
              v.$data.error.code = error.response.data.code;
              v.$data.error.show = true;
            }, 1000);
          });
      }
    },
    goToPasswordReset() {
      this.$router.push({ name: "MobilePasswordReset" });
    }
  },
  mounted() {
    if (localStorage.loginEmail && localStorage.loginPassword) {
      this.$data.login = false;
      this.$data.loader = true;

      axios
        .post(this.$store.getters.getApiUrl + "/api/login", {
          email: localStorage.loginEmail,
          password: localStorage.loginPassword
        })
        .then(response => {
          if (response.data.token.length > 0) {
            this.$store.commit("loginSuccess", {
              token: response.data.token,
              isLoggedIn: true,
              currentUser: response.data.currentUser
            });

            this.$store.commit("setIsAppState", {
              isApp: true
            });

            var v = this;

            setTimeout(function() {
              v.$data.loader = false;
              v.$router.push({ path: "/home" });
            }, 2000);
          }
        })
        .catch(error => {
          // console.log('error', error.response.data);

          var v = this;

          setTimeout(function() {
            v.$data.loader = false;
            v.$data.login = true;
            v.$data.error.message = error.response.data.message;
            v.$data.error.code = error.response.data.code;
            v.$data.error.show = true;
          }, 1000);
        });
    }
  }
};
</script>
